import api from '@/api/api';
import type {
  MetricCreatePayload,
  MetricDeleteReport,
  MetricItem,
  MetricOptions,
  MetricWritePayload,
} from '@/interfaces/Metrics';

/** Allowed units and the metric_code pattern for the metrics form. */
export const getMetricOptions = async (): Promise<MetricOptions> => {
  const response = await api.get<MetricOptions>('/metrics/options');
  return response.data;
};

export const createMetric = async (payload: MetricCreatePayload): Promise<MetricItem> => {
  const response = await api.post<MetricItem>('/metrics', payload);
  return response.data;
};

export const updateMetric = async (metricCode: string, payload: MetricWritePayload): Promise<MetricItem> => {
  const response = await api.put<MetricItem>(`/metrics/${encodeURIComponent(metricCode)}`, payload);
  return response.data;
};

/** Dry run: what a delete would remove, without deleting anything. */
export const getMetricDeletePreview = async (metricCode: string): Promise<MetricDeleteReport> => {
  const response = await api.get<MetricDeleteReport>(`/metrics/${encodeURIComponent(metricCode)}/delete-preview`);
  return response.data;
};

export const deleteMetric = async (metricCode: string): Promise<MetricDeleteReport> => {
  const response = await api.delete<MetricDeleteReport>(`/metrics/${encodeURIComponent(metricCode)}`);
  return response.data;
};
